module.exports = "/images/icon_loud03.png?0822d27706ab75e693a3d279ec747fe5";